<template>
    <div class="public-wrapper">
        <div class="container">
            <header>
                <router-link :to="{name: 'login'}">
                    <img src="@/assets/images/logo.svg" alt="Sympatia" class="logo">
                </router-link>
            </header>
            <div class="content-wrapper">
                <img :src="publicPath + 'images/public-image.jpg'" alt="Sympatia" class="img-fluid">
                <div class="card">
                    <div class="card-body p-5">
                        <router-view/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {publicPath} from "../../main";

    export default {
        name: "Public",
        mounted() {
            this.$store.dispatch('account/get');
        },
        watch: {
            '$store.state.account.profile': {
                deep: true,
                handler(newValue) {
                    if (newValue !== null && newValue) {
                        if (newValue.activated === true) {
                            this.$router.push({name: 'dashboard'});
                        } else if (this.$route.name !== 'verification') {
                            this.$router.push({name: 'verification'});
                        }
                    }
                }
            }
        },
        data() {
            return {
                publicPath: publicPath
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/styles/variables.scss";

    .public-wrapper {
        header {
            margin-top: 40px;
            margin-bottom: 40px;

            @include media-breakpoint-down(md) {
                margin-top: 30px;
                margin-bottom: 30px;

                .logo {
                    height: 40px;
                }
            }
        }

        .content-wrapper {
            margin: 0 auto;
            width: 100%;
            max-width: 865px;
            position: relative;

            > .card {
                @include media-breakpoint-up(sm) {
                    position: absolute;
                    width: 345px;
                    bottom: -40px;
                    right: -40px;
                }
                @include media-breakpoint-up(xl) {
                    bottom: -80px ! important;
                    right: -80px ! important;
                }
                @include media-breakpoint-up(sm) {
                    bottom: -40px;
                    right: -40px;
                }

                @include media-breakpoint-only(sm) {
                    bottom: -80px ! important;
                }
                @include media-breakpoint-only(xs) {
                    margin: -10px 10px 0;
                }
            }
        }
    }
</style>